{
  "menu": {
    "labels": {
      "overview": "Übersicht",
      "procedures": "Studienangebote",
      "dossierdownloader": "Sammelakten-Download"
    }
  }
}
